import {css} from 'lit';
export const styles = css`:host {
  --app-primary-color: #01965f;
  --app-primary-color-400: #017243;

  --app-secondary-color: black;

  --accent-color: var(--google-red-500);
  --accent-color-400: var(--google-red-300);

  --accent-home: var(--google-red-500);
  --accent-home-400: var(--google-red-300);
  --accent-away: var(--google-green-500);
  --accent-away-400: var(--google-green-300);
}

app-header {
    background-color: #01965f;
    color: #FFF;
}

paper-icon-button {
    --paper-icon-button-ink-color: white;
}

app-drawer-layout:not([narrow]) [drawer-toggle] {
    display: none;
}

.drawer-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.spacer {
    flex-grow: 1;
}

.drawer-list {
    margin: 0 20px;
}

.drawer-list a {
    display: block;
    padding: 0 16px;
    text-decoration: none;
    color: var(--app-secondary-color);
    line-height: 40px;
    cursor: pointer;
}

.drawer-list a.iron-selected {
    color: black;
    font-weight: bold;
}`;
export default styles;
